import { firestore } from "../init/firebase";
import { CollectionReference, DocReference, Query } from "../types/firebase.types";
import { AppResource } from "../types/resource.types";

export const getCollRef = (name: string): CollectionReference => firestore.collection(name);
export const getDocRef = (path: string): DocReference => firestore.doc(path);
export const getCGRef = (name: string): Query => firestore.collectionGroup(name);

// collections
export const courtsCollRef = getCollRef(AppResource.courts);
export const clientsCollRef = getCollRef(AppResource.clients);
export const sportsClubsCollRef = getCollRef(AppResource.sportsClubs);
export const courtsReservationsCollRef = getCollRef(AppResource.courtsReservations);
export const brandsCollRef = getCollRef(AppResource.brands);
export const agentsCollRef = getCollRef(AppResource.agents);
export const brandsCategoriesCollRef = getCollRef(AppResource.brandsCategories);
export const productsCollRef = getCollRef(AppResource.products);
export const placessCollRef = getCollRef(AppResource.places);
export const ordersReservationsCollRef = getCollRef(AppResource.orders);
export const requestCollRef = getCollRef(AppResource.visitsRequests);
export const productsFilesCollRef = getCollRef(AppResource.productsFiles);
export const gymsCollRef = getCollRef(AppResource.gyms);
export const cancellationPoliciesCollRef = getCollRef(AppResource.cancellationPolicies);
export const notificationsCollectionRef = getCollRef(AppResource.notifications);
export const academiesCollRef = getCollRef(AppResource.academies);
export const coachesCollRef = getCollRef(AppResource.coaches);
export const coachesReservationsCollRef = getCollRef(AppResource.coachReservations);
export const sportTypesCollRef = getCollRef(AppResource.sportTypes);
export const entertainmentsCollRef = getCollRef(AppResource.entertainments);

// documents
export const adminRef = (adminId: string) => getDocRef(`${AppResource.admins}/${adminId}`);
export const courtDocRef = (courtId: string) => getDocRef(`${AppResource.courts}/${courtId}`);
export const sportClubDocRef = (clubId: string) => getDocRef(`${AppResource.sportsClubs}/${clubId}`);
export const brandDocRef = (brandId: string) => getDocRef(`${AppResource.brands}/${brandId}`);
export const clientDocRef = (clientId: string) => getDocRef(`${AppResource.clients}/${clientId}`);
export const roomDocRef = (roomId: string) => getDocRef(`${AppResource.rooms}/${roomId}`);
export const productDocRef = (productId: string) => getDocRef(`${AppResource.products}/${productId}`);
export const courtReservationDocRef = (reservationId: string) =>
  getDocRef(`${AppResource.courtsReservations}/${reservationId}`);
export const orderReservationDocRef = (orderId: string) => getDocRef(`${AppResource.orders}/${orderId}`);
export const orderDocRef = (orderId: string) => getDocRef(`${AppResource.orders}/${orderId}`);
export const requestDocRef = (requestId: string) => getDocRef(`${AppResource.visitsRequests}/${requestId}`);
export const agentDocRef = (agentId: string) => getDocRef(`${AppResource.agents}/${agentId}`);
export const placeDocRef = (placeId: string) => getDocRef(`${AppResource.places}/${placeId}`);
export const visitRequestDocRef = (requestId: string) => getDocRef(`${AppResource.visitsRequests}/${requestId}`);
export const gymDocRef = (gymId: string) => getDocRef(`${AppResource.gyms}/${gymId}`);
export const academyDocRef = (academyId: string) => getDocRef(`${AppResource.academies}/${academyId}`);
export const gymPackageDocRef = (gymId: string, packageId: string) =>
  getDocRef(`${AppResource.gyms}/${gymId}/${AppResource.packages}/${packageId}`);
export const academyPackageDocRef = (academyId: string, packageId: string) =>
  getDocRef(`${AppResource.academies}/${academyId}/${AppResource.packages}/${packageId}`);
export const coachDocRef = (coachId: string) => getDocRef(`${AppResource.coaches}/${coachId}`);
export const coachReservationDocRef = (reservationId: string) =>
  getDocRef(`${AppResource.coachReservations}/${reservationId}`);
export const entertainmentDocRef = (entertainmentId: string) =>
  getDocRef(`${AppResource.entertainments}/${entertainmentId}`);

// subCollections
export const courtsAvailabilitiesRangesSubCollRef = (courtId: string) =>
  courtDocRef(courtId).collection(AppResource.courtsAvailabilitiesRanges);
export const courtsSlotsSubCollRef = (courtId: string) => courtDocRef(courtId).collection(AppResource.courtsSlots);
export const roomMessagesSubCollRef = (roomId: string) => roomDocRef(roomId).collection(AppResource.roomMessages);
export const brandsMediaSubCollRef = (brandId: string) => brandDocRef(brandId).collection(AppResource.brandsMedia);
export const brandsDeliveryMethodsSubCollRef = (brandId: string) =>
  brandDocRef(brandId).collection(AppResource.brandsDeliveryMethods);

export const sportClubSettingsCollRef = (clubId: string) =>
  sportClubDocRef(clubId).collection(AppResource.settings).doc("general");
export const brandSettingsCollRef = (brandId: string) =>
  brandDocRef(brandId).collection(AppResource.settings).doc("general");
export const gymSettingsCollRef = (gymId: string) => gymDocRef(gymId).collection(AppResource.settings).doc("general");
export const gymPackagesCollRef = (gymId: string) => gymDocRef(gymId).collection(AppResource.packages);
export const gymWalletsCollRef = (gymId: string) => gymDocRef(gymId).collection(AppResource.wallets);
export const academyPackagesCollRef = (academyId: string) => academyDocRef(academyId).collection(AppResource.packages);
export const academySettingsCollRef = (academyId: string) =>
  academyDocRef(academyId).collection(AppResource.settings).doc("general");
export const coachSettingsCollRef = (coachId: string) =>
  coachDocRef(coachId).collection(AppResource.settings).doc("general");
export const entertainmentSettingsCollRef = (entertainmentId: string) =>
  entertainmentDocRef(entertainmentId).collection(AppResource.settings).doc("general");
export const coachSlotsSubCollRef = (coachId: string) => coachDocRef(coachId).collection(AppResource.coachSlots);
export const coachAvailabilitiesRangesSubCollRef = (coachId: string) =>
  coachDocRef(coachId).collection(AppResource.coachAvailabilityRanges);

export const coachesReviewsSubCollRef = (coachId: string) => coachDocRef(coachId).collection(AppResource.coachReviews);
export const sportClubReviewsSubCollRef = (clubId: string) =>
  sportClubDocRef(clubId).collection(AppResource.sportsClubsReviews);
export const gymReviewsSubCollRef = (gymId: string) => gymDocRef(gymId).collection(AppResource.gymReviews);
export const academyReviewsSubCollRef = (academyId: string) =>
  academyDocRef(academyId).collection(AppResource.academyReviews);
export const entertainmentReviewsSubCollRef = (entertainmentId: string) =>
  entertainmentDocRef(entertainmentId).collection(AppResource.entertainmentReviews);

// collection group
export const sportsClubsReviewsCG = getCGRef(AppResource.sportsClubsReviews);
export const gymReviewsCG = getCGRef(AppResource.gymReviews);
export const academyReviewsCG = getCGRef(AppResource.academyReviews);
export const coachReviewsCG = getCGRef(AppResource.coachReviews);
export const entertainmentReviewsCG = getCGRef(AppResource.entertainmentReviews);
